/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

export { TediousInstrumentation } from './instrumentation';
export type { TediousInstrumentationConfig } from './types';
